module.exports = __webpack_public_path__ + "static/media/stool-filter.503027a5.jpeg";